// import "./TFDAccelerateCamps.css";
import "./AccelerateGlobal.css";

import { Link } from "react-router-dom";
import React from "react";

export default function TFDAccelerateCamps() {
  return (
    <div className="tfd-accelerate-camps-page">
      {/* HERO SECTION */}
      <section className="tf-hero-camps">
        <div className="hero-image-wrap">
          <img
            src="/images/accelerate/camps-hero.jpg"
            alt="Accelerate Camps Hero"
            className="hero-bg-image"
          />
          <div className="overlay-dark" />
          <div className="hero-content themeflat-container">
            <h1 className="hero-title wow fadeInUp animated">
              TFD ACCELERATE Camps
            </h1>
            <p className="hero-subtitle wow fadeInUp animated">
              Intensive training experiences to elevate your game.
            </p>
            <Link to="/contact" className="flat-button wow fadeInUp animated">
              View Camp Schedules
            </Link>
          </div>
        </div>
      </section>

      {/* CAMPS INFO SECTION */}
      <section className="tf-camps-info main-content">
        <div className="themeflat-container">
          <div className="title-box center-title-box title-large">
            <h2 className="title-section wow fadeInUp animated">
              Upcoming Accelerate Camps
            </h2>
            <p className="sub-title wow fadeInUp animated">
              Gear up for dynamic training sessions that boost skills and performance.
            </p>
          </div>

          {/* Camp Cards */}
          <div className="row">
            <div className="col-md-4 wow fadeInUp animated">
              <div className="camp-card">
                <img
                  src="/images/accelerate/camp1.jpg"
                  alt="Youth Ignite Camp"
                  className="camp-image"
                />
                <h4 className="camp-title">Youth Ignite Camp (U8–U10)</h4>
                <p className="camp-dates">July 10th – July 12th</p>
                <p className="camp-desc">
                  Introducing young talents to the basics of football with a focus on agility, coordination, and fun.
                </p>
              </div>
            </div>

            <div className="col-md-4 wow fadeInUp animated" data-wow-delay="0.2s">
              <div className="camp-card">
                <img
                  src="/images/accelerate/camp2.jpg"
                  alt="Pro Development Camp"
                  className="camp-image"
                />
                <h4 className="camp-title">Pro Development Camp (U11–U13)</h4>
                <p className="camp-dates">August 5th – August 7th</p>
                <p className="camp-desc">
                  Elevate your skills with advanced drills, tactical sessions, and personalized coaching.
                </p>
              </div>
            </div>

            <div className="col-md-4 wow fadeInUp animated" data-wow-delay="0.4s">
              <div className="camp-card">
                <img
                  src="/images/accelerate/camp3.jpg"
                  alt="Elite Mastery Camp"
                  className="camp-image"
                />
                <h4 className="camp-title">Elite Mastery Camp (U14+)</h4>
                <p className="camp-dates">September 15th – September 17th</p>
                <p className="camp-desc">
                  Intensive sessions focused on refining techniques, building mental toughness, and developing leadership.
                </p>
              </div>
            </div>
          </div>

          <div className="text-center mt-5">
            <Link to="/contact" className="flat-button wow fadeInUp animated">
              Contact Us for More Info
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
